import React from 'react';
import TextField from '../../../components/inputs/textField';
import { TextLead } from '@awarego-ui/components';

const TextFieldWithRevert = ({ field, defaultValue, onRevert }) => {
    const hasDefaultValue = defaultValue !== undefined && defaultValue !== null;
    const isDifferent = hasDefaultValue && field.value !== defaultValue;

    const handleRevert = () => {
        if (hasDefaultValue && onRevert) {
            onRevert(field.name, defaultValue);
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <TextField field={field} />
            {isDifferent && (
                <TextLead
                    themed
                    bold
                    link
                    role="button"
                    tabIndex={0}
                    onClick={handleRevert}
                    title="Revert to default"
                    style={{
                        position: 'absolute',
                        right: '8px',
                        top: '8px',
                        fontSize: '11px',
                    }}
                >
                    Revert to default
                </TextLead>
            )}
        </div>
    );
};

export default TextFieldWithRevert;

